module.exports = __webpack_public_path__ + "img/fake_user_avatar.c6a57028.png";